import React from "react";
import "./styles/Invoice.css";

export default function InvoiceHeader() {
  return (
    <div className="invoice-header">
      <h1>Invoice</h1>
      <h2>Up2date Technology Solutions, LLC</h2>
    </div>
  );
}